var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart",staticClass:"chart-funnel",style:({ height: _vm.height + 'px', width: _vm.width + 'px' })})
}
var staticRenderFns = []

export { render, staticRenderFns }